import React from 'react';
import { Form, Input, Select, DatePicker, InputNumber, Button, Space, Row, Col, Card, Typography } from 'antd';
import { Equipment } from '../../types';
import { EQUIPMENT_CATEGORIES, EQUIPMENT_STATUS, EQUIPMENT_CONDITION, MAINTENANCE_SCHEDULES } from '../../constants';

const { Option } = Select;
const { TextArea } = Input;
const { Title } = Typography;

interface EquipmentFormProps {
  form: any;
  equipment: Equipment | null;
  onSave: (values: any) => Promise<void>;
  onCancel: () => void;
}

const EquipmentForm: React.FC<EquipmentFormProps> = ({
  form,
  equipment,
  onSave,
  onCancel,
}) => {
  const handleSubmit = async (values: any) => {
    try {
      await onSave(values);
    } catch (error) {
      console.error('Error saving equipment:', error);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      initialValues={equipment || {
        category: 'Strength',
        status: 'Available',
        condition: 'Excellent',
        maintenanceSchedule: 'Monthly',
        maxUsers: 1,
        currentUsers: 0,
        utilization: 0,
      }}
    >
      <Row gutter={16}>
        <Col span={24}>
          <Card title="Basic Information" size="small">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="Equipment Name"
                  rules={[{ required: true, message: 'Please enter equipment name' }]}
                >
                  <Input placeholder="Enter equipment name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="category"
                  label="Category"
                  rules={[{ required: true, message: 'Please select category' }]}
                >
                  <Select>
                    {Object.values(EQUIPMENT_CATEGORIES).map(category => (
                      <Option key={category} value={category}>
                        {category}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="status"
                  label="Status"
                  rules={[{ required: true, message: 'Please select status' }]}
                >
                  <Select>
                    {Object.values(EQUIPMENT_STATUS).map(status => (
                      <Option key={status} value={status}>
                        {status}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="brand" label="Brand">
                  <Input placeholder="Enter brand" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="model" label="Model">
                  <Input placeholder="Enter model" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="serialNumber" label="Serial Number">
                  <Input placeholder="Enter serial number" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row justify="end" style={{ marginTop: 24 }}>
        <Col>
          <Space>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {equipment ? 'Update Equipment' : 'Create Equipment'}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default EquipmentForm; 